export const MAX_ITEM_TITLE_LENGTH = 48;
